import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { GridColDef } from '@mui/x-data-grid-pro';
import { useSchedulingRuleQuery } from './useSchedulingRuleQuery';
import { useSchedulingRuleTableState } from './useSchedulingRuleTableState';

export const useSchedulingRuleTable = () => {
    const { t } = useTranslation();
    const { rows, setRows, loading, setLoading, loadData } = useSchedulingRuleQuery();
    const { contextMenu, setContextMenu, selectedRow, setSelectedRow, selected, setSelected, cleanSelected } = useSchedulingRuleTableState();

    const columns: GridColDef[] = useMemo(
        () => [
            {
                field: 'name',
                headerName: t('scheduling_rules.scheduling_rule.table.columns.name'),
                flex: 1,
            },
            {
                field: 'description',
                headerName: t('scheduling_rules.scheduling_rule.table.columns.description'),
                flex: 2,
                renderCell: (params) => (params.value ? params.value : '--'),
            },
        ],
        [t],
    );

    const reloading = useCallback(() => {
        loadData().finally(() => {
            setContextMenu(null);
            cleanSelected();
        });
    }, [cleanSelected, loadData, setContextMenu]);

    return {
        rows,
        setRows,
        loading,
        setLoading,
        loadData,
        columns,
        reloading,
        contextMenu,
        setContextMenu,
        selectedRow,
        setSelectedRow,
        selected,
        setSelected,
        cleanSelected,
    };
};
